import { render } from "./Onboarding.vue?vue&type=template&id=195b46e2&scoped=true"
import script from "./Onboarding.vue?vue&type=script&lang=js"
export * from "./Onboarding.vue?vue&type=script&lang=js"

import "./Onboarding.vue?vue&type=style&index=0&id=195b46e2&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src3621675308/src/competition/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-195b46e2"]])

export default __exports__